import { render, staticRenderFns } from "./AiPhotoValidationEmptyState.vue?vue&type=template&id=22a931b4&"
import script from "./AiPhotoValidationEmptyState.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiPhotoValidationEmptyState.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports